import Widgets from './extend/Widgets';
import Widget from './components/Widget';

export default {
  'extensions/afrux-forum-widgets-core/common/extend/Widgets': Widgets,
  'extensions/afrux-forum-widgets-core/common/components/Widget': Widget,
};
